import DevError from '/shared/errors/DevError';
import type { QuestionCollection, QuestionTreeItem } from '/business/shared/functions/types';

export default function flattenQuestions(
  questionsData: QuestionCollection | null | undefined = null,
  flattenSubQuestions = false,
): QuestionTreeItem[] {
  if (!questionsData || !Array.isArray(questionsData)) {
    throw new DevError('Bad data sent to flattenQuestions');
  }
  const output: QuestionTreeItem[] = [];
  const recurSubQuestion = (question: QuestionTreeItem | null = null) => {
    question?.subQuestions?.forEach((subQuestion) => {
      if (!subQuestion) {
        return;
      }
      output.push({ ...subQuestion, flattened: true });
      if (subQuestion?.subQuestions && subQuestion?.subQuestions?.length > 0) {
        recurSubQuestion(subQuestion);
      }
    });
  };
  questionsData.forEach((section = null) => {
    if (!section) {
      return;
    }
    if (section.flattened) {
      output.push(section);
      return;
    }
    if (!section.groups) {
      return;
    }
    section.groups.forEach((group) => {
      if (!group?.questions) {
        return;
      }
      group.questions.forEach((question) => {
        if (!question) {
          return;
        }
        if (flattenSubQuestions) {
          if (question?.subQuestions && question?.subQuestions?.length > 0) {
            recurSubQuestion(question);
          }
          if (question.apiKey) {
            output.push({ ...question, flattened: true });
          }
          return;
        }
        output.push({ ...question, flattened: true });
      });
    });
  });
  return output;
}
